module.exports = __webpack_public_path__ + "img/16.26bd471c.jpg";